const imagePath = '/images/cases/design-991/'

export const config = {
  title: 'user research:',
  description:
    'We interviewed several active e-learning platform users to identify the motivation, expectations, and issues they face while utilizing design learning and teaching apps. Here are the most popular answers.',
  users: [
    {
      image: `${imagePath}kiryl.webp`,
      imageAlt: 'Kiryl, Product Designer',
      info: [
        {
          title: 'Kiryl, 31',
          description: `Product\nDesigner`,
        },
        {
          title: 'Motivation',
          description: 'Improve own\nskills, start a new\ncourse in\nmarketing',
        },
        {
          title: 'expectations',
          description: 'Feedback, new\ndesigner\ncommunity,\nmentoring',
        },
        {
          title: 'pain',
          description: 'Unclear course\nstructure,\nfeedback',
        },
      ],
    },
    {
      image: `${imagePath}anita.webp`,
      imageAlt: 'Anita, Freelancer',
      info: [
        {
          title: 'Anita, 25',
          description: 'Freelancer',
        },
        {
          title: 'Motivation',
          description: 'Get an offer in a\ndesign studio',
        },
        {
          title: 'expectations',
          description: 'Mentoring,\ncourses for\nUI/UX design,\nchat',
        },
        {
          title: 'pain',
          description:
            'Searching for the\nspecific materials\nis time-consuming',
        },
      ],
    },
    {
      image: `${imagePath}lenar.webp`,
      imageAlt: 'Lenar, Graphic Designer',
      info: [
        {
          title: 'Lenar, 27',
          description: 'Graphic\nDesigner',
        },
        {
          title: 'Motivation',
          description: 'Start a new\ncourse in 3D\ndesign',
        },
        {
          title: 'expectations',
          description: 'New designer\ncommunity,\nmentoring',
        },
        {
          title: 'pain',
          description:
            'Can’t choose the\nbest course, had not\nconversations with\nother 3D designers',
        },
      ],
    },
    {
      image: `${imagePath}ramil.webp`,
      imageAlt: 'Ramil, Art Director',
      info: [
        {
          title: 'Ramil, 38',
          description: 'Art\nDirector',
        },
        {
          title: 'Motivation',
          description: 'A lot of free time,\nwants to teach\npeople design',
        },
        {
          title: 'expectations',
          description: 'Big group of\nstudents, chat,\nfeedback',
        },
        {
          title: 'pain',
          description:
            'Lack of a platform\nwhere you can train\nstudents of various\ntype of design',
        },
      ],
    },
  ],
}
